import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { ReactSVG } from 'react-svg';
import cn from 'classnames';
import teams from 'src/constants/teams';

import { requestJoinToSport } from '../../store/actionCreators/joinToSport';
import Button from '../common/Button';
import ConfirmModal from '../common/ConfirmModal';

import './styles.scss';

interface TeamsListProps {
    missionId: number;
    progressiveMissionId: number;
    submissionTeamInfo: Record<string, string>;
}

const TeamsList: FC<TeamsListProps> = ({ missionId, progressiveMissionId, submissionTeamInfo }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [showAll, setShowAll] = useState<boolean>(false);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [teamData, setTeamData] = useState<Record<string, any>>({});
    const chooseTeamInfoLength = submissionTeamInfo && Object.keys(submissionTeamInfo)?.length;
    const visibleTeams = showAll ? teams : teams.slice(0, 7);

    const handleTeamClick = (team: { id: number; name: string; logo: string }) => {
        const data = {
            teamInfo: {
                id: team.id,
                name: team.name,
                url: team.logo,
            },
            missionId,
            progressiveMissionId,
        };
        setTeamData(data);
        setIsModalOpen(true);
    };

    const handleOk = () => {
        dispatch(requestJoinToSport(teamData));
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <div className={cn('container', { containerTeamInfo: chooseTeamInfoLength > 0 })}>
            {isModalOpen && chooseTeamInfoLength === undefined && (
                <ConfirmModal
                    isModalOpen={isModalOpen}
                    handleCancel={handleCancel}
                    handleOk={handleOk}
                    className={'confirmModal'}
                    title={'confirmChoose'}
                    teamData={teamData?.teamInfo}
                    footerInfo={'note'}
                    selectTeamBonusInfo={'selectTeamBonus'}
                />
            )}
            <p className="chooseTeam">{chooseTeamInfoLength === undefined ? t('chooseTeam') : t('yourTeam')}</p>
            {chooseTeamInfoLength > 0 && (
                <div className="teamsList">
                    <div className="teamsList__list">
                        <p key={submissionTeamInfo.id}>
                            <img src={submissionTeamInfo.url} alt={submissionTeamInfo.name} width={18} height={18} />
                            <span>{submissionTeamInfo.name}</span>
                        </p>
                    </div>
                </div>
            )}
            {chooseTeamInfoLength === undefined && (
                <div className="teamsList">
                    <div className="teamsList__list">
                        {visibleTeams.map((team) => (
                            <p key={team.id} onClick={() => handleTeamClick(team)}>
                                <img src={team.logo} alt={team.name} width={18} height={18} />
                                <span>{team.name}</span>
                            </p>
                        ))}
                    </div>

                    {teams.length > 7 && (
                        <Button onClick={() => setShowAll((prev) => !prev)}>
                            <span> {showAll ? t('showLess') : t('showMore')}</span>
                            <ReactSVG className={cn('arrow', { arrowRotate: showAll })} src="/static/images/chevron_right.svg" />
                        </Button>
                    )}
                </div>
            )}
        </div>
    );
};
export default TeamsList;
